import React, { useEffect, useRef  } from 'react'
import './Advisor.scss'
export const Advisor = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
          videoRef.current.playbackRate = 1; // 0.5x speed (half speed)
        }
      }, []);

    return (
        <>
            <section className="page-header advisor-banner member-section">
                <video ref={videoRef} autoPlay muted loop playsInline>
                    <source src="https://www.oneworldnetwork.co/video/1wn-boa.mp4" type="video/mp4" />
                </video>
           
                <div className="page-header__bg post-event-gallery-banner">
                </div>
           
            </section>
            <section className='advisor-section'>
                <div className='global-img-sec'><img src="/images/resources/globe-png.png" alt="" /></div>
                <div className='container'>
                    <div className='row advisor-content one'>
                        <div className='col-lg-7 col-md-12'>
                            <h3>Mat Burton 
                            </h3>
                            <p>With over 4 decades of experience in logistics and aviation, Mat is a distinguished leader known for driving operational excellence and large-scale transformations. As a former Deputy Director at Heathrow for British Airways, he spearheaded key cargo handling and infrastructure projects. Now an independent consultant, his expertise in crisis management, supplier negotiations, and logistics strategy continues to shape the industry's future. 

</p>
                        </div>
                        <div className='col-lg-4 col-md-12 offset-lg-1'>
                            <img src="/images/resources/Mat Burton.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </section>
            <section className='advisor-section'>
                <div className='global-img-sec right'><img src="/images/resources/globe-png.png" alt="" /></div>
                <div className='container'>
                    <div className='row advisor-content'>
                        <div className='col-lg-4 col-md-12'>
                        <img src="/images/resources/dr-renu-singh-parmar.jpg" alt="" />
                        </div>
                        <div className='col-lg-7 col-md-12 offset-lg-1'>
                            <h3>Dr. Renu Parmar 
                            </h3>
                            <p>A visionary leader in economic policy and aviation logistics, Dr. Parmar brings over 3 decades of expertise as a retired Indian Economic Service officer. Her pivotal role in shaping India’s air cargo sector, including spearheading the National Aviation University, has earned her prestigious accolades like the Golden Chariot Award. Her strategic insights continue to drive efficiency and innovation in global logistics.  </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='advisor-section'>
                <div className='global-img-sec'><img src="/images/resources/globe-png.png" alt="" /></div>
                <div className='container'>
                    <div className='row advisor-content one'>
                        <div className='col-lg-7 col-md-12'>
                            <h3>Mr. P. Balasubramanian 
                            </h3>
                            <p>With over 40 years of international experience, Mr. Bala is a global authority in air cargo and logistics. As Founder & CEO of ACCIS and a former Emirates Airline executive, he has played a key role in shaping industry regulations through ICAO, IATA, and IAEA. A renowned speaker and compliance expert, he advises leading organizations on air transport and safety strategies. 
 </p>
                        </div>
                        <div className='col-lg-4 col-md-12 offset-lg-1'>
                            <img src="/images/resources/Mr. P. Balasubramanian.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </section>
       
            <section className='advisor-section'>
                <div className='global-img-sec right'><img src="/images/resources/globe-png.png" alt="" /></div>
                <div className='container'>
                    <div className='row advisor-content'>
                        <div className='col-lg-4 col-md-12'>
                            <img src="/images/resources/Ms. Kathrin Reuter.jpg" alt="" />
                        </div>
                        <div className='col-lg-7 col-md-12 offset-lg-1'>
                            <h3>Ms. Kathrin Reuter
                            </h3>
                            <p>A logistics industry stalwart with over 30 years of experience, Ms. Reuter is the Managing Director of Embassy Freight Services Europe. Her expertise spans supply chain optimization, freight forwarding, and strategic growth. A trusted leader, she is instrumental in driving operational excellence and customer-centric solutions within the global logistics network. 
 </p>
                        </div>
                    </div>
                </div>
            </section>
           
        
        </>
    )
}
